const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
};

export { ACTIONS };
